import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MinuteRequestApprovalConditionDTO, MinuteApprovalConditionComparator, MinuteRequestApprovalRuleDetailDTO } from '../../interfaces/minute-request-approval-rule.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NewMinuteRequestConditionsViewModel, RemoveMinuteRequestApprovalConditionRequestDTO, UpdateMinuteRequestApprovalRuleConditionViewModel, UpdateMinuteRequestApprovalRuleViewModel } from '../../interfaces/minute-request-approval-rule-manage.interface';

@Component({
  selector: 'app-minute-request-approval-rule-detail',
  templateUrl: './minute-request-approval-rule-detail.component.html',
  styleUrls: ['./minute-request-approval-rule-detail.component.scss']
})
export class MinuteRequestApprovalRuleDetailComponent implements OnInit, OnChanges{
  @Input() minuteRequestApprovalRuleDetail: MinuteRequestApprovalRuleDetailDTO;
  @Input() canUpdateApprovalRule: boolean = true;
  @Output() removeMinuteRequestCondition = new EventEmitter<RemoveMinuteRequestApprovalConditionRequestDTO>;
  @Output() updateMinuteRequestCondition = new EventEmitter<UpdateMinuteRequestApprovalRuleConditionViewModel>;
  @Output() registerNewConditions = new EventEmitter<NewMinuteRequestConditionsViewModel>;

  @ViewChild(MatPaginator, {static: true}) conditionPaginator: MatPaginator;
  public conditionsDataSource: MatTableDataSource<MinuteRequestApprovalConditionDTO>;
  public conditionTableCols = [
    'parameterName',
    'comparator',
    'value'
  ];

  public labelComparators = MinuteApprovalConditionComparator;

  constructor(){
    this.conditionsDataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.setConditionsTable(this.minuteRequestApprovalRuleDetail.conditions);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setConditionsTable(this.minuteRequestApprovalRuleDetail.conditions);
  }

  private setConditionsTable(conditions: MinuteRequestApprovalConditionDTO[]){
    this.conditionsDataSource.data = conditions || [];
    this.conditionsDataSource.paginator = this.conditionPaginator;
  }

  public clickRemoveCondition(conditionId: number) {
    const request : RemoveMinuteRequestApprovalConditionRequestDTO = {
      minuteRequestConditionId: conditionId,
      minuteRequestRuleId: this.minuteRequestApprovalRuleDetail.minuteRequestApprovalRuleId
    };
    this.removeMinuteRequestCondition.emit(request);
  }

  public clickNewMinuteApprovalConditions() {
    const viewModel: NewMinuteRequestConditionsViewModel = {
      minuteRequestApprovalRuleId: this.minuteRequestApprovalRuleDetail.minuteRequestApprovalRuleId,
      name:this.minuteRequestApprovalRuleDetail.name
    };
    this.registerNewConditions.emit(viewModel);
  }

  public clickUpdateCondition(condition:MinuteRequestApprovalConditionDTO) {
    const updateViewModel: UpdateMinuteRequestApprovalRuleConditionViewModel = {
      minuteRequestApprovalParameterId: condition.minuteApprovalParameterId,
      minuteRequestApprovalConditionId: condition.minuteRequestApprovalRuleConditionId,
      comparator: condition.comparator,
      value: condition.value,
      minuteRequestApprovalRuleId: this.minuteRequestApprovalRuleDetail.minuteRequestApprovalRuleId
    };
    this.updateMinuteRequestCondition.emit(updateViewModel);
  }

}
